define(['warmupUtilsLib'], function (warmupUtilsLib) {
    'use strict';

    return warmupUtilsLib.svgFeatureDetection;
});
